export default __webpack_public_path__ + "static/whatsappAiCRM-bdccc33169e1d029f3f4e95bbaaca056.svg";